<div class="agency-contact-form-container">
  <form fxFlex="1 1 100%;" #registerForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="selectedUser!==null && selectedUser!==undefined">
    <mat-card fxFlex>
      <mat-card-header fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">
          <span *ngIf="addOrEditInd === 'A'">Add Agency {{ addressMode ? 'Address' : 'Contact' }}</span>
          <span *ngIf="addOrEditInd === 'E'">Edit Agency {{ addressMode ? 'Address' : 'Contact' }}</span>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>

        <ng-container *ngIf="!addressMode">
          <div class="user-form-main" fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="8px grid">
            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Prefix</mat-label>
              <input matInput id="prefix" name="prefix" [(ngModel)]="selectedUser.prefix" />
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>First Name</mat-label>
              <input matInput id="firstName" name="firstName" [(ngModel)]="selectedUser.first_Name" #firstName="ngModel" required />
              <mat-error *ngIf="firstName.invalid && firstName.touched">First Name is required</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Middle Initial</mat-label>
              <input matInput id="middleInitial" name="middleInitial" [(ngModel)]="selectedUser.middle_initial" maxlength="1" />
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Last Name</mat-label>
              <input matInput id="lastName" name="lastName" [(ngModel)]="selectedUser.last_Name" #lastName="ngModel" required />
              <mat-error *ngIf="lastName.invalid && lastName.touched">Last Name is required</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Suffix</mat-label>
              <input matInput id="suffix" name="suffix" [(ngModel)]="selectedUser.suffix" />
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Email</mat-label>
              <input matInput id="email" name="email" [(ngModel)]="selectedUser.email" #email="ngModel" required email appEmailExist />
              <mat-error *ngIf="email.invalid && email.touched && email.dirty && email.errors?.['exists']">Email already in use</mat-error>
              <mat-error *ngIf="email.invalid && email.touched && email.dirty && email.errors?.['error']">{{email.errors?.['error']}}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Phone Number</mat-label>
              <input matInput id="phoneNumber" name="phoneNumber" [(ngModel)]="selectedUser.phone_No" #phoneNumber="ngModel" required (input)="checkPhone(phoneNumber)" />
              <mat-error *ngIf="phoneNumber.invalid && phoneNumber.touched">{{phoneNumber.errors?.['error'] ? phoneNumber.errors?.['error'] : 'Phone Number is required.'}}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Fax Number</mat-label>
              <input matInput id="faxNumber" name="faxNumber" [(ngModel)]="selectedUser.fax_No"  #faxNumber="ngModel" (input)="checkPhone(faxNumber)"  />
              <mat-error *ngIf="faxNumber.invalid && faxNumber.touched">{{faxNumber.errors?.['error'] ? faxNumber.errors?.['error'] : 'Fax Number is invalid.'}}</mat-error>
            </mat-form-field>

          </div>

        </ng-container>

        <ng-container *ngIf="showAddress">

          <div *ngIf="!addressMode" class="agency-address" role="heading" aria-level="1">Agency Address</div>

          <div class="user-form-address" fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="8px grid">

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Address</mat-label>
              <input matInput id="address1" name="address1" [(ngModel)]="selectedUser.address1"
                     appGmapAutocom (selectedPlace)="placeChanged($event)">
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Address 2</mat-label>
              <input matInput id="address2" name="address2" [(ngModel)]="selectedUser.address2" />
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>City</mat-label>
              <input matInput id="city" name="city" [(ngModel)]="selectedUser.city" />
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>State</mat-label>
              <input matInput id="state" name="state" [(ngModel)]="selectedUser.state" />
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Zip Code</mat-label>
              <input matInput id="zip_Code" name="zip_Code" [(ngModel)]="selectedUser.zip_Code" />
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxFlex.lt-lg="45%" fxFlex.lt-md="100%" appearance="outline" floatLabel="always">
              <mat-label>Country</mat-label>
              <input matInput id="country" name="country" [(ngModel)]="selectedUser.country" />
            </mat-form-field>

          </div>

        </ng-container>

      </mat-card-content>

      <mat-card-actions fxLayoutAlign="center" fxLayoutGap="10px">
        <button mat-raised-button color="primary" type="submit"
                (click)="btnClicked.emit({eventCode: 'S', savedUser: selectedUser})"
                [disabled]="!canSave(registerForm) || saving" class="spinner-black">
          <div *appSpinner="saving"></div>
          Save
        </button>
        <button mat-raised-button
                color="accent" type="button"
                (click)="btnClicked.emit('C')"
        >
          Cancel
        </button>
        <button *ngIf="addOrEditInd === 'E' && !showAddress"
                mat-raised-button
                type="button" color="warn"
                (click)="btnClicked.emit('D')">
          Delete User
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
